/**
 * 身份证号码验证
 */
import request from '@/utils/request'

// 身份证号码验证
export function apiPostCheckLawyerInfo (params) {
  return request({
    url: '/lawyer/file/checkLawyerInfo',
    method: 'get',
    params
  })
}

// 身份证号码验证
export function apiGetdelete (params) {
  return request({
    url: '/lawyer/file/delete',
    method: 'get',
    params
  })
}